import { z } from "zod";
import { EPresenceType } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";

export const absenceGroupSchema = z.object({
  name: z
    .string()
    .min(1, "Nazwa grupy jest wymagana.")
    .max(100, "Nazwa grupy jest za długa, maksymalnie 100 znaków"),
  description: z.optional(
    z
      .string()
      .max(255, "Opis grupy jest za długi, maksymalnie 255 znaków")
      .nullable()
  ),
  presenceType: z.enum(EPresenceType),
  order: z
    .number({ message: "Należy wprowadzić liczbę od 1 do 99." })
    .min(1, "Priorytet musi być większy od 0.")
    .max(99, "Priorytet nie może być większy niż 99."),
  color: z.string().length(7).regex(/^#/, "Nieprawidłowy format koloru."),
});
